import { configApi } from '../../http-client.js'

export const getIabText = languageCode =>
	configApi.get('api/Vendors/IabStaticText?languageCode=' + languageCode)

export const putIabText = languageOpts => configApi.put('api/vendors/iabstatictext', languageOpts)
